<app-label-inflator #labelCalculator hidden [labelComponentInterface]="data"></app-label-inflator>

<div
  class="product-card-variant-name"
  appPrintCardScaleDownText
  [maxHeightInPx]="20"
  [maxWidthInPx]="248"
  [transparentWhileScaling]="masterKushStrainViewModel.viewingInLiveView$ | async"
  [style.color]="masterKushStrainViewModel.bodyTextColor$ | async">
  {{ data | sectionRowViewModelBasicMethod: 'getRowTitleForFirstRowVariant' | trimSafely }}
</div>
<div class="product-card-badges-strain-sizes-and-labels">
  <div
    *ngIf="(data?.menu | printCardMenuBasicMethod: 'getNumberOfBadgesForVariant' : data) > 0"
    class="badge-container">
    <img
      *ngFor="let variantBadge of data | allVariantBadges"
      appImage
      class="badge"
      [asset]="variantBadge?.image"
      alt="badge"
      src="" />
  </div>
  <div class="product-card-strain-and-size">
    <ng-container
      *ngIf="
        !(masterKushStrainViewModel.isAccessory$ | async) &&
        !(masterKushStrainViewModel.isNonCannabinoidOtherVariant$ | async) &&
        (data | sectionRowViewModelBasicMethod: 'getReadableStrainTypeForFirstRowVariant' | trimSafely) as strainType
      ">
      <div class="product-card-strain" [style.color]="masterKushStrainViewModel.bodyTextColor$ | async">
        {{ strainType | uppercase }}
      </div>
      <div *ngIf="hasAssortedSizes">|</div>
    </ng-container>
    <div
      *ngIf="
        hasAssortedSizes &&
        (data | sectionRowViewModelBasicMethod: 'getGridQuantityAndSizeString' : variant | trimSafely) as size
      ">
      {{ size }}
    </div>
  </div>

  <app-label-inflator class="print-card-label" [columnLabel]="false" [labelComponentInterface]="data" [reset]="false">
  </app-label-inflator>
</div>
<div class="product-card-properties-container">
  <ng-container *ngFor="let data of viewModel.propertiesSortedForDisplay$ | async">
    <div class="property-container">{{ data?.title }} {{ data?.value }}</div>
  </ng-container>
</div>
